import axios from "axios";
import { API_URL } from "../_config/config.const";
import { handleResponse } from "../_helpers/handleResponse.helper";
import { getHeader, getUploadHeader } from "../_helpers/header.helper";
import { getBody } from "../_helpers/body.helper";

const API_NAME = "userInformation";

export const userInformationService = {
    get,
    getAddressInformation,
    profileImageUpdate,
    getProfileImage,
    updateAddress,
    getInformation,
    updateInformation,
    updateInsuranceInformation,
    merge
};

function get(id: string) {
    const requestOptions = { method: 'GET', headers: getHeader() };
    return fetch(`${API_URL}/${API_NAME}/Get/?id=${id}`, requestOptions).then(handleResponse);
}

function getProfileImage(userId: string) {
    const requestOptions = { method: 'GET', headers: getHeader() };
    return fetch(`${API_URL}/${API_NAME}/getProfileImage/?userId=${userId}`, requestOptions).then(handleResponse);
}

function getAddressInformation(id: string) {
    const requestOptions = { method: 'GET', headers: getHeader() };
    return fetch(`${API_URL}/${API_NAME}/GetAddressInformation/?id=${id}`, requestOptions).then(handleResponse);
}

function updateAddress(model?: any) {
    const requestOptions = { method: 'PUT', headers: getHeader(), body: getBody(model) };
    return fetch(`${API_URL}/${API_NAME}/updateAddress`, requestOptions).then(handleResponse);
}

function getInformation(id: string) {
    const requestOptions = { method: 'GET', headers: getHeader() };
    return fetch(`${API_URL}/${API_NAME}/GetInformation/?id=${id}`, requestOptions).then(handleResponse);
}

function updateInformation(model?: any) {
    const requestOptions = { method: 'PUT', headers: getHeader(), body: getBody(model) };
    return fetch(`${API_URL}/${API_NAME}/UpdateInformation`, requestOptions).then(handleResponse);
}

function merge(model?: any) {
    const requestOptions = { method: 'PUT', headers: getHeader(), body: getBody(model) };
    return fetch(`${API_URL}/${API_NAME}/merge`, requestOptions).then(handleResponse);
}

function updateInsuranceInformation(model?: any) {
    const requestOptions = { method: 'PUT', headers: getHeader(), body: getBody(model) };
    return fetch(`${API_URL}/${API_NAME}/updateInsuranceInformation`, requestOptions).then(handleResponse);
}


function profileImageUpdate(model?: FormData) {
    const config = {
        headers: getUploadHeader()
    }

    return axios.put(`${API_URL}/${API_NAME}/ProfileImageUpdate`, model, config);
}
